import React from 'react';
import GoogleMapReact from 'google-map-react';

import LocationMarker from '@components/map/location-marker';
import LocationMarkerWithBookButton from '@components/map/marker-with-book-button';
import { Loader } from '@components/shared/loader';
import { MapProps } from '@models/common/map';
import { Location } from '@models/location';
import { useLocations } from '@services/yoga-sauna';

const googleMapAPIKey: string = process.env.NEXT_PUBLIC_GOOGLE_KEY as string;
const Map: React.FunctionComponent<MapProps> = ({
  defaultZoom,
  markerWithBookButton,
  hideInfoPin,
  offSetCenter,
}) => {
  const { data: locations = [], isLoading } = useLocations();
  const [location] = locations;
  const lat = location?.latitude || '34.01945400000';
  const lng = location?.longitude || '-118.4021116';
  const offSetCenterVal = offSetCenter ? 0.03 : 0.0;

  const renderPin = (loc: Location) =>
    markerWithBookButton ? (
      <LocationMarkerWithBookButton
        key={loc?.id}
        location={loc}
        lat={Number(loc?.latitude)}
        lng={Number(loc?.longitude)}
      />
    ) : (
      <LocationMarker
        key={loc?.id}
        location={loc}
        lat={Number(loc?.latitude)}
        lng={Number(loc?.longitude)}
        hideInfoPin={hideInfoPin}
      />
    );

  const createMapOptions = () => ({
    styles: [{ stylers: [{ saturation: -20 }, { visibility: 'on' }] }],
  });

  return isLoading ? (
    <Loader />
  ) : (
    <GoogleMapReact
      bootstrapURLKeys={{ key: googleMapAPIKey, language: 'en' }}
      defaultCenter={{ lat: Number(lat) + offSetCenterVal, lng: Number(lng) }}
      defaultZoom={defaultZoom}
      options={createMapOptions}
    >
      {renderPin(location)}
    </GoogleMapReact>
  );
};

Map.defaultProps = {
  defaultZoom: 12,
  markerWithBookButton: false,
  hideInfoPin: false,
  offSetCenter: false,
};
export default Map;
